import Img from "next/image";
import React, { ReactElement } from "react";

import { ApiResponseError } from "@/apis/errors";
import { ToTopButton } from "@/components/molecules/buttons/ToTopButton";

interface Props {
  error?: ApiResponseError;
}

export default function Error400Page({ error }: Props) {
  return (
    <div className="p-8 text-center md:p-24">
      <div className="m-auto w-[201px] h-[222px]">
        <Img src={`/customer/img/404-robot.svg`} width={201} height={222} alt="" />
      </div>
      <h1 className="mt-10 text-5xl font-medium md:text-7xl">
        <span>{error?.status}</span>{" "}
        <span className="text-4xl md:text-5xl">{error?.message}</span>
      </h1>
      {error?.errors.map((error, idx) => (
        <p key={idx} className="mt-2 text-lg md:text-2xl">
          {error.message}
        </p>
      ))}
      <ToTopButton />
    </div>
  );
}

Error400Page.getLayout = function getLayout(page: ReactElement) {
  return <>{page}</>;
};
